import { render, staticRenderFns } from "./orderResult.vue?vue&type=template&id=73055d20&scoped=true&"
import script from "./orderResult.vue?vue&type=script&lang=js&"
export * from "./orderResult.vue?vue&type=script&lang=js&"
import style0 from "./orderResult.vue?vue&type=style&index=0&id=73055d20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73055d20",
  null
  
)

export default component.exports